import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from '../InputField';
import SelectField from '../SelectField';
import CheckboxField from '../CheckboxField';
import FormError from '../FormError';
import states from 'helpers/states';

let PaymentMethodForm = ({ handleSubmit, error }) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field
        component={InputField}
        type="number"
        name="card_number"
        label="*Card Number"
      />
      <Field
        component={InputField}
        type="number"
        name="expiration_month"
        label="*Expiry Month (MM)"
      />
      <Field
        component={InputField}
        type="number"
        name="expiration_year"
        label="*Expiry Year (YY)"
      />
      <Field component={InputField} type="number" name="cvc" label="*CVC" />
      <Field component={InputField} name="first_name" label="First Name" />
      <Field component={InputField} name="last_name" label="Last Name" />
      <Field component={InputField} name="address" label="Address" />
      <Field component={InputField} name="city" label="City" />
      <Field
        component={SelectField}
        name="state"
        label="State"
        empty="Choose a state"
        options={states.map((state) => [state.abbreviation, state.name])}
      />
      <Field component={InputField} name="zip_code" label="Zip Code" />
      <Field component={CheckboxField} name="is_default" label="Is default?" />

      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-default">Save Payment Method</button>
    </form>
  </div>
);

const validate = (values) => {
  let errors = {};

  if (!values.card_number) {
    errors.card_number = 'Required';
  }

  if (!values.expiration_month) {
    errors.expiration_month = 'Required';
  }

  if (values.expiration_month && values.expiration_month.length !== 2) {
    errors.expiration_month = 'Month must be exactly two digits';
  }

  if (!values.expiration_year) {
    errors.expiration_year = 'Required';
  }

  if (values.expiration_year && values.expiration_year.length !== 2) {
    errors.expiration_year = 'Year must be exactly two digits';
  }

  if (!values.cvc) {
    errors.cvc = 'Required';
  }

  if (values.state && values.state.length !== 2) {
    errors.state = 'State must be the 2 character abbreviation';
  }

  if (values.zip_code && values.zip_code.length !== 5) {
    errors.zip_code = 'Zip Code must be exactly 5 digits';
  }

  const addressFields = {
    first_name: values.first_name,
    last_name: values.last_name,
    address: values.address,
    city: values.city,
    state: values.state,
    zip_code: values.zip_code,
  };

  const isAddressFieldPopulated = Object.values(addressFields).filter(
    (field) => field,
  );
  if (isAddressFieldPopulated.length > 0) {
    Object.keys(addressFields).forEach((key) => {
      if (!addressFields[key]) {
        errors[key] = 'Required';
      }
    });
  }

  return errors;
};

PaymentMethodForm = reduxForm({
  form: 'paymentMethods',
  validate,
})(PaymentMethodForm);

export default PaymentMethodForm;
